module.exports = __webpack_public_path__ + "static/img/dataLeakInstallForMac_pic9.086e45d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dataLeakInstallForMac/dataLeakInstallForMac_pic9.png
// module id = 488
// module chunks = 1